import {DispatchRequestStatus, dispatchRequestStatus} from "@ots-frontend/ots-data";
import {ReactNode} from "react";
import * as CSS from "csstype";
import {
    dispatchRequestAcceptedColor,
    dispatchRequestCanceledColor,
    dispatchRequestCompletedColor,
    dispatchRequestPendingColor,
    dispatchRequestPickedUpColor,
    dispatchRequestReassignedColor,
    dispatchRequestRejectedColor,
    dispatchRequestStartedColor,
    dispatchRequestUnresovledColor,
    grayColor
} from "../theme/colors";
import {
    FaCheck,
    FaExchangeAlt,
    FaHourglassHalf,
    FaLevelUpAlt,
    FaThumbsDown,
    FaThumbsUp,
    FaTimesCircle
} from "react-icons/fa";

export const getDispatchRequestStatusColor = (
    status: DispatchRequestStatus
): CSS.Property.Color => {
    switch (status) {
        case dispatchRequestStatus.pending:
            return dispatchRequestPendingColor;
        case dispatchRequestStatus.started:
            return dispatchRequestStartedColor;
        case dispatchRequestStatus.accepted:
            return dispatchRequestAcceptedColor;
        case dispatchRequestStatus.pickedUp:
            return dispatchRequestPickedUpColor;
        case dispatchRequestStatus.reassigned:
            return dispatchRequestReassignedColor;
        case dispatchRequestStatus.rejected:
            return dispatchRequestRejectedColor;
        case dispatchRequestStatus.pendingCancel:
        case dispatchRequestStatus.canceled:
            return dispatchRequestCanceledColor;
        case dispatchRequestStatus.completed:
            return dispatchRequestCompletedColor;
        case dispatchRequestStatus.unresolved:
            return dispatchRequestUnresovledColor;
        default:
            return grayColor;
    }
};

export const getDispatchRequestStatusColorRef = (
    status: DispatchRequestStatus
): string => {
    switch (status) {
        case dispatchRequestStatus.pending:
            return "dispatch-request-pending";
        case dispatchRequestStatus.started:
            return "dispatch-request-started";
        case dispatchRequestStatus.accepted:
            return "dispatch-request-accepted";
        case dispatchRequestStatus.pickedUp:
            return "dispatch-request-picked-up";
        case dispatchRequestStatus.reassigned:
            return "dispatch-request-reassigned";
        case dispatchRequestStatus.rejected:
            return "dispatch-request-rejected";
        case dispatchRequestStatus.pendingCancel:
        case dispatchRequestStatus.canceled:
            return "dispatch-request-canceled";
        case dispatchRequestStatus.completed:
            return "dispatch-request-completed";
        default:
            return "dispatch-request-unresolved";
    }
};

/**
 * Returns the icon react node for the dispatch request status.
 *
 * @param status the status
 */
export const getDispatchRequestStatusIcon = (
    status: DispatchRequestStatus
): ReactNode | undefined => {
    switch (status) {
        case dispatchRequestStatus.pending:
            return <FaHourglassHalf/>;
        case dispatchRequestStatus.started:
            return <span className="iconify" data-icon="mdi-tanker-truck"></span>;
        case dispatchRequestStatus.accepted:
            return <FaThumbsUp/>;
        case dispatchRequestStatus.pickedUp:
            return <FaLevelUpAlt/>;
        case dispatchRequestStatus.reassigned:
            return <FaExchangeAlt/>;
        case dispatchRequestStatus.rejected:
            return <FaThumbsDown/>;
        case dispatchRequestStatus.pendingCancel:
        case dispatchRequestStatus.canceled:
        case dispatchRequestStatus.unresolved:
            return <FaTimesCircle/>;
        case dispatchRequestStatus.completed:
            return <FaCheck/>;
        default:
            return undefined;
    }
};
